export const isEventFull = (eventItem) => Number(eventItem?.status_full) === 1;
